import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[ebComponentHost]',
    standalone: false
})
export class EbComponentHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}

